import { useMutation } from '@tanstack/react-query';
import { WalletYearlyReportMutationParamsType } from './walletYearlyReportMutation.type';
import { walletYearlyReportFunction } from './walletYearlyReportMutationFunction';

export const walletYearlyReportMutationOptions = (
  params: WalletYearlyReportMutationParamsType,
) => {
  return useMutation({
    mutationKey: ['yearly-report', params],
    mutationFn: () => walletYearlyReportFunction(params),
  });
};
